function showSheetError(sheet, message) {
  if (message) {
    $('.error-message', sheet).html(message);
  }
  $('.error-body', sheet).show();
  $('.add-body', sheet).hide();
  $('.success-body', sheet).hide();
  $('.report-body', sheet).hide();
}
function initializeUsernameCheck() {
  const field = $('input[name="username"]');
  const field_group = (field.parent('.input-group').length > 0) ? field.parent('.input-group') : field;
  if (field.length) {
    const results_div = $('<div class="mt-1" style="display:none;"></div>');
    const checking_html = '<span class="text-muted"><i class="fa fa-cog fa-spin"></i> checking...</span>';
    const success_html = '<span class="text-success"><i class="fa fa-check"></i> Username is available!</span>';
    const fail_html = '<span class="text-danger"><i class="fas fa-do-not-enter"></i> Sorry, that username is not available.</span>';
    results_div.insertAfter(field_group);
    field.on('keyup', _.debounce(function() {
      results_div.html(checking_html);
      if (field.val().length >= 5) {
        results_div.show();
        fetch('/members/checkusername/?candidate=' + field.val(), {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': Cookies.get('csrftoken')
          },
          credentials: 'same-origin'
        }).then(response => {
          if (!response.ok) {
            throw new Error('Whoops!');
          }
          return response.json();
        }).then(data => {
          if (data.result == 'available') {
            results_div.html(success_html)
          } else {
            results_div.html(fail_html)
          }
        }).catch(error => {
          console.log(error);
          results_div.hide();
        });
      } else {
        results_div.hide();
      }
    }, 300));
  }
}
function getAddToListMenu(callback) {
  fetch('/api/lists/', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken')
    },
    credentials: 'same-origin'
  }).then(response => {
    if (!response.ok) {
      throw new Error('There was a problem getting your lists.');
    }
    return response.json();
  }).then(data => {
    const lists = data.results;
    let wrapper = $('#existingListsWrapper');
    localStorage.setItem('lists', JSON.stringify(lists));
    localStorage.setItem('listskey', data.lists_key);

    createAddToListMenu(lists, wrapper);
    if (callback) {
      callback();
    }
  }).catch(error => {
    showSheetError($('#addToListSheet'), error.message);
  });
}
function createAddToListMenu(lists, wrapper) {
  if (typeof lists === 'string') {
    lists = JSON.parse(lists);
  }
  let listRows = '';
  for (let i = 0; i < lists.length; i++) {
    var listCheck = '';
    let row = `<div class="list-group-item"><div class="d-flex w-100 justify-content-between"><div class="form-check"><input class="form-check-input" type="checkbox" id="listCheck${lists[i].id}" name="lists" value="${lists[i].id}" ${listCheck}><label class="form-check-label" for="listCheck${lists[i].id}">${lists[i].name}<div class="list-owner">a <strong>${lists[i].privacy}</strong> list by <strong>${lists[i].owner.username}</strong></div></label></div><div class="go-to-list"><a href="${lists[i].absolute_url}" target="_blank"><i class="fal fa-cog"></i> edit list</a></div></div></div>`;

    listRows += row;
  }
  wrapper.html('<div class="list-group">' + listRows + '</div>');
  enableAddToListButtons();
}
function createAddToListMenuFromLocalStorage(user) {
  let lists = localStorage.getItem('lists');
  if (lists) {
    let wrapper = $('#existingListsWrapper');
    createAddToListMenu(lists, wrapper);
  }
}
window.createAddToListMenuFromLocalStorage = createAddToListMenuFromLocalStorage;
function populateAddToListSheet() {
  if (!window.idx.userAuthenticated) {
    showLoginSheet();
  } else {
    const listSheet = $('#addToListSheet');
    const model = $(this).data('model');
    const oid = $(this).data('oid');
    const objectName = $(this).data('objectName');
    $('input[name=model]', listSheet).val(model);
    $('input[name=oid]', listSheet).val(oid);
    $('input[name=object_name]', listSheet).val(objectName);
    if (objectName) {
      $('.object-name', listSheet).html(objectName);
    }
    overlayOn(listSheet);
    $('.add-to-list-sheet input[type=checkbox]').prop('checked', false);
    if (!$('#existingListsWrapper').html()) {
      var getLists = function() {
        getListsItemIsOn(model, oid, objectName, listSheet);
      };
      getAddToListMenu(getLists);
    } else {
      getListsItemIsOn(model, oid, objectName, listSheet);
    }
  }
}
function getListsItemIsOn(model, oid, objectName, listSheet) {
  fetch('/api/lists/?model=' + model + '&oid=' + oid, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken')
    },
    credentials: 'same-origin'
  }).then(response => {
    if (!response.ok) {
      throw new Error('There was a problem getting your lists.');
    }
    return response.json();
  }).then(data => {
    if (data.meta && data.meta.auth == false) {
      showLoginSheet();
    } else {
      if (!objectName && data.object) {
        $('.object-name', listSheet).html(data.object.name);
      }
      if (!data.object) {
        showSheetError(listSheet);
      } else {
        if (!$('#existingListsWrapper').html()) {
          $('#newUserListIntro').show();
          $('#listCheckNew').prop('checked', true);
          $('#newListInput').collapse('show');
          setTimeout(function () {
            $('#newListInput input').val('My New List').select().focus();
          }, 500);
        } else {
          $('#existingListsHeader').show();
          for (let i = 0; i < data.results.length; i++) {
            $('#listCheck' + data.results[i].id).prop('checked', true).attr('data-on-list', 'true');
          }
        }
      }
    }
    overlayOff(listSheet);
  }).catch(error => {
    console.log(error.message);
    showSheetError(listSheet);
  });
}
function clearAddToListSheet() {
  const listSheet = $('#addToListSheet');
  $('.object-name', listSheet).html('');
  $('.add-body', listSheet).show();
  $('.success-body', listSheet).hide();
  $('.error-body', listSheet).hide();
  $('.error-text', listSheet).html('');
  $('.error-message', listSheet).html('');
  $('.collapse', listSheet).removeClass('show');
  $('.form-check-input', listSheet).prop('checked', false).attr('data-on-list', '');
  $('input[name=newListName], textarea[name=note]', listSheet).val('');
  $('#newUserListIntro').hide();
  $('#newListInput').collapse('hide');
  $('#listCheckNew').prop('checked', false);
}
function saveListItems(el) {
  const listSheet = $('#addToListSheet');
  let listIds = [];
  let removeListIds = [];
  $.each($('input[name=lists]:checked', listSheet), function () {
    listIds.push($(this).val());
  });
  $.each($('input[data-on-list="true"]:not(:checked)', listSheet), function () {
    removeListIds.push($(this).val());
  });
  let newListName = ($('#listCheckNew', listSheet).prop('checked')) ? $('input[name=newListName]', listSheet).val() : '';
  let objectModel = $('input[name=model]', listSheet).val();
  let objectOid = $('input[name=oid]', listSheet).val();
  let objectName = $('input[name=object_name]', listSheet).val();
  const data = {
    'model': objectModel,
    'oid': objectOid,
    'add_lists': listIds,
    'remove_lists': removeListIds,
    'note': $('textarea[name=note]', listSheet).val(),
    'new': newListName
  };
  if (listIds.length == 0 && removeListIds.length == 0 && newListName == '') {
    $('.error-text', listSheet).html('Whoops! You have to select at least one list to add this to.');
    $('.list-wrapper', listSheet).addClass('flash-anim');
    setTimeout(function() {
      $('.list-wrapper', listSheet).removeClass('flash-anim');
    }, 1000);
  } else {
    var buttonText = $('.add-btn', listSheet).html();
    $('.add-btn', listSheet).html('<i class="fa fa-spinner fa-spin"></i>').attr('disabled', true);
    fetch('/api/lists/update_item/', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': Cookies.get('csrftoken')
      },
      credentials: 'same-origin'
    }).then(response => {
      if (!response.ok) {
        throw new Error('There was a problem getting your lists.');
      }
      return response.json();
    }).then(data => {
      $('.add-btn', listSheet).html(buttonText).attr('disabled', false);
      $('.add-body', listSheet).hide();
      $('.success-body', listSheet).show();
      // add new list to list of lists
      if (newListName) {
        $('#existingListsWrapper', listSheet).html('');
        getAddToListMenu();
      }
      // return lists this item is on
      $('ul.added-lists', listSheet).html('');
      $('ul.removed-lists', listSheet).html('');
      if(data.successes.add.length == 0) {
        $('.added-to-container', listSheet).hide();
      } else {
        $('.added-to-container', listSheet).show();
      }
      if(data.successes.remove.length == 0) {
        $('.removed-from-container', listSheet).hide();
      } else {
        $('.removed-from-container', listSheet).show();
      }
      for (let i = 0; i < data.successes.add.length; i++) {
        $('ul.added-lists', listSheet).append(`<li><a href="${data.successes.add[i].absolute_url}">${data.successes.add[i].name}</a> <small class="text-muted fs-6">by ${data.successes.add[i].owner.username}</small></li>`);
      }
      for (let i = 0; i < data.successes.remove.length; i++) {
        $('ul.removed-lists', listSheet).append(`<li><a href="${data.successes.remove[i].absolute_url}">${data.successes.remove[i].name}</a> <small class="text-muted fs-6">by ${data.successes.remove[i].owner.username}</small></li>`);
      }
      if (data.list_count > 0 && data.successes.add.length > 0) {
        let listMsg;
        if (data.list_count == 1) {
          listMsg = `This is on your <a href="${data.successes.add[0].absolute_url}"><strong>${data.successes.add[0].name}</strong></a> list.`;
        } else {
          listMsg = `This is on <a href="/account/lists/?item=${data.url_id}"><strong>${data.list_count} of your lists</strong></a>.`;
        }
        $('#itemListBar-'+data.url_id).html(listMsg).show();
      } else {
        $('#itemListBar-' + data.url_id).html('').hide();
      }
      dataLayer.push({
        'event': 'addedItemToList',
        'itemModel': objectModel,
        'itemId': objectOid,
        'itemDesc': objectName
      });
    }).catch(error => {
      console.log(error.message);
      $('.add-btn', listSheet).html(buttonText).attr('disabled', false);
      showSheetError(listSheet);
    });
  }
}
function overlayOn(container) {
  $('.skelly', container).show();
  $('.display-item', container).hide();
}
function overlayOff(container) {
  $('.display-item', container).show();
  $('.skelly', container).hide();
}
function likeObject(model, oid, button) {
  if (model && oid) {
    $(button).children('.like-btn-heart:first').addClass('heartbeat');
    let data = {
      'model': model,
      'oid': oid,
      'type': 'like'
    };
    fetch('/api/member-items/', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'X-CSRFToken': Cookies.get('csrftoken'),
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    })
    .then(response => response.json())
    .then(data => {
      if (data.result == "success") {
        toggleLike('like', button, data.id, true);
        dataLayer.push({
          'event': 'likedItem',
          'itemModel': `${model}`,
          'itemId': `${oid}`,
          'itemDesc': `${data.item_description}`
        });
      }
    })
    .catch(error => {
      console.log(error);
    });
  }
}
function unlikeObject(memberItemId, button, action) {
  if (memberItemId) {
    if (action != 'remove') {
      $(button).children('.like-btn-heart:first').addClass('heartbeat');
    }
    fetch(`/api/member-items/${memberItemId}/`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': Cookies.get('csrftoken')
      },
      credentials: 'same-origin'
    }).then(response => {
      if (!response.ok) {
        throw new Error('There was a problem getting your lists.');
      } else {
        if (action == 'remove') {
          $(button).parents('.list-item').hide('slow', function () { $(this).remove(); });
        } else {
          toggleLike('unlike', button, memberItemId, true);
        }
      }
    }).catch(error => {
      console.log(error.message);
    });
  }
}
function getLikedObjects(model, oid) {
  if (model && oid) {
    var oids = (typeof (oid) == 'string') ? oid.split(',') : (typeof (oid) == 'number') ? [oid] : oid;
    var oidParams = '';
    for (let i = 0; i < oids.length; i++) {
      oidParams += `&oid=${oids[i]}`;
    }
    fetch('/api/member-items/likes_and_lists/?type=like&model=' + model + oidParams, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': Cookies.get('csrftoken')
      },
      credentials: 'same-origin'
    }).then(response => {
      if (!response.ok) {
        throw new Error('There was a problem getting your likes and lists.');
      }
      return response.json();
    }).then(data => {
      for (let i = 0; i < data.results.length; i++) {
        let button = $(`.like-btn[data-oid=${data.results[i].oid}][data-model="${model}"]`);
        toggleLike('like', button, data.results[i].id, false);
        if (data.results[i].list_count > 0) {
          let listMsg;
          if (data.results[i].list_count == 1) {
            listMsg = `This is on your <a href="${data.results[i].lists[0].url}"><strong>${data.results[i].lists[0].name}</strong></a> list.`;
          } else {
            listMsg = `This is on <a href="/account/lists/?item=${data.results[i].url_id}"><strong>${data.results[i].list_count} of your lists</strong></a>.`;
          }
          $('#itemListBar-' + data.results[i].url_id).html(listMsg).show();
        }
      }
    }).catch(error => {
      console.log(error.message);
    });
  }
}
function toggleLike(action, el, id, countLike) {
  let likeCount = $(el).data('likeCount');
  if (action == 'like') {
    $(el).addClass('liked');
    $(el).find('.like-btn-heart').removeClass('fa-regular text-dark').addClass('fa-solid text-danger');
    $(el).data('itemId', id);
  } else if (action == 'unlike') {
    $(el).removeClass('liked');
    $(el).find('.like-btn-heart').removeClass('fa-solid text-danger').addClass('fa-regular text-dark');
    $(el).data('itemId', '');
  }
  if (countLike) {
    if (action == 'like') { likeCount++; } else { likeCount--; }
    $(el).data('likeCount', likeCount);
    var likeText = (likeCount == 1) ? 'like' : 'likes';
    $(el).parent().find('.like-btn-count').html(likeCount);
    $(el).parent().find('.like-btn-count-text').html(likeText);
  }
  setTimeout(() => {
    $(el).children('.like-btn-heart:first').removeClass('heartbeat');
  }, 1500);
}
export function showLoginSheet() {
  $('.offcanvas-sheet').each(function() {
    var ocSheet = bootstrap.Offcanvas.getOrCreateInstance($(this));
    ocSheet.hide();
  });
  var loginSheet = document.getElementById('loginSheet');
  var ocSheet = bootstrap.Offcanvas.getOrCreateInstance(loginSheet);
  ocSheet.show();
}
function copyToClipboard(el) {
  const input = (typeof el === 'object') ? el.select() : document.getElementById(el).select();
  document.execCommand("copy");
}
function sendReport() {
  const reportSheet = $('#reportSheet');
  const reportText = $('[name=report]', reportSheet).val();
  const model = $('[name=model]', reportSheet).data('model');
  const oid = $('[name=oid]', reportSheet).data('oid');
  let offcanvas = $('#reportSheet');
  let data = {
    'oid': oid,
    'model': model,
    'report': reportText
  };
  fetch('/api/reports/', {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken')
    },
    credentials: 'same-origin'
  }).then(response => {
    if (!response.ok) {
      throw new Error();
    }
    return response.json();
  }).then(results => {
    $('.report-body', offcanvas).hide();
    $('.error-body', offcanvas).hide();
    $('.success-body', offcanvas).show();
  }).catch(error => {
    console.log(error.message);
    showSheetError(offcanvas);
  });
}
function enableAddToListButtons() {
  $('.atl-button-skelly').hide();
  $('.atl-button-container').show();
}
window.enableAddToListButtons = enableAddToListButtons;
export function showToast(message) {
  var toast = $('#toastElem');
  var clone = toast.clone();
  var toastId = Math.random().toString(36).substring(2,7);
  clone.attr('id', 'toast-' + toastId);
  $('.toast-body', clone).html(message);
  $('.toast-container').append(clone);
  clone.toast('show');
}
$(function() {
  // Event delegation for buttons that were previously using inline onClick handlers
  $(document).on('click', '[data-action="save-list-items"]', function(e) {
    e.preventDefault();
    saveListItems();
  });
  $(document).on('click', '[data-action="send-report"]', function(e) {
    e.preventDefault();
    sendReport();
  });

  // Use event delegation so the handler is always registered regardless of
  // whether the /members/menu/ XHR has completed yet (fixes race condition).
  $(document).on('click', '.add-to-list-btn', populateAddToListSheet);
  if (window.idx.userLoaded) {
    enableAddToListButtons();
  }
  var atlOffcanvas = document.getElementById('addToListSheet');
  if (atlOffcanvas) {
    atlOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
      clearAddToListSheet();
    });
  }
  var nlCollapsible = document.getElementById('newListInput');
  if (nlCollapsible) {
    nlCollapsible.addEventListener('hidden.bs.collapse', function (el) {
      $('input', el.target).val('');
    });
    nlCollapsible.addEventListener('show.bs.collapse', function (el) {
      setTimeout(function () {
        $('input', el.target).focus();
      }, 200);
    });
  }
  var likeData = {};
  $('.like-btn').each(function () {
    let model = $(this).data('model');
    let oid = $(this).data('oid');
    if (model in likeData) {
      likeData[model].push(oid);
    } else {
      likeData[model] = [oid];
    }
  });
  for (let i = 0; i < Object.keys(likeData).length; i++) {
    let key = Object.keys(likeData)[i];
    getLikedObjects(key, likeData[key]);
  }
  $('.like-btn').on('click', function(e) {
    if (!window.idx.userAuthenticated) {
      showLoginSheet();
    } else {
      const model = $(this).data('model');
      const oid = $(this).data('oid');
      const memberItemId = $(this).data('itemId');
      if ($(this).hasClass('liked')) {
        unlikeObject(memberItemId, this);
      } else {
        likeObject(model, oid, this);
      }
    }
    e.preventDefault();
  });
  $('.remove-like-btn').on('click', function(e) {
    if (!window.idx.userAuthenticated) {
      showLoginSheet();
    } else {
      var conf = confirm('Are you sure you want to remove this from your likes?');
      if (conf) {
        const memberItemId = $(this).data('itemId');
        unlikeObject(memberItemId, this, 'remove');
      }
    }
    e.preventDefault();
  });
  $('.report-btn').on('click', function (e) {
    if (!window.idx.userAuthenticated) {
      showLoginSheet();
    } else {
      const model = $(this).data('model');
      const oid = $(this).data('oid');
      const objectName = $(this).data('objectName');
      var reportSheet = document.getElementById('reportSheet');
      $('.report-body', reportSheet).show();
      $('.error-body', reportSheet).hide();
      $('.success-body', reportSheet).hide();
      $('[name=model]', reportSheet).data('model', model);
      $('[name=oid]', reportSheet).data('oid', oid);
      if (objectName) {
        $('.object-name', reportSheet).html(objectName);
      }
      var ocSheet = bootstrap.Offcanvas.getOrCreateInstance(reportSheet);
      ocSheet.show();
      $('.error-body', reportSheet).hide();
      e.preventDefault();
    }
  });

  initializeUsernameCheck();

  $(function () {
    $('[data-toggle="tooltip"]').tooltip()
  });
});
